module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"searchChemicalsTitle":"Chemical Information","myChemicalsTooltip":"Filter only chemicals you have associated to your account","myChemicals":"My chemicals","noChemicalsFound":"No chemicals found!","chemicalNameOrPartNumber":"Chemical name or item no.","recentlyUpdated":"Recently Updated","searchResults":"Search Results"}}')
  delete Component.options._Ctor
}
